import { Custom } from '@authFlow/utils/authFlowFlags';
import { storageManager } from '@authFlow/utils/SessionStorageManager';
import { sendEvent } from '@utils/sendEvent';
import { isCustom } from '@authFlow/utils/signupHelpers';

import type { AuthMethodT } from '@authFlow/types/types';

const EVENT_CATEGORY = 'signup_flow';

export function sendSignupFlowEvent(
  eventAction?: string,
  eventLabel?: string,
  callback?: () => void,
) {
  const {
    eventActions = [],
    eventLabels = [],
    traceId = null,
  } = storageManager.get('signupFlowEvents') || {
    eventActions: [],
    eventLabels: [],
    traceId: null,
  };

  if (
    (eventAction ? eventActions.includes(eventAction) : true) &&
    (eventLabel ? eventLabels.includes(eventLabel) : true)
  ) {
    callback && callback();
    return false;
  }

  eventActions.push(eventAction);
  eventLabels.push(eventLabel);
  storageManager.set({
    signupFlowEvents: { eventActions, eventLabels, traceId },
  });
  sendEvent(
    EVENT_CATEGORY,
    eventAction,
    eventLabel,
    callback,
    JSON.stringify({ traceId }),
  );
}

export function getSignupFlowGaLabel(): 'promo' | 'subscribe' | 'default' {
  if (
    storageManager.get('promo') ||
    storageManager.get('custom') === Custom.promo
  )
    return 'promo';

  if (storageManager.get('offer')) return 'subscribe';

  return 'default';
}

export function getAuthMethod(authMethod?: AuthMethodT): AuthMethodT | 'email' {
  if (authMethod === 'form' || !authMethod) return 'email';

  return authMethod;
}

export function getSignupFlowGaState(): 'base' | 'copilot' | 'customisation' {
  const custom = storageManager.get('custom');

  if (isCustom(Custom.copilot)) {
    return 'copilot';
  }

  if (custom && custom !== 'promo' && custom !== 'secure') {
    return 'customisation';
  }

  return 'base';
}
